"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_baidu_maps_1 = require("react-baidu-maps");
var defaultZoom = 15;
var defaultCenter = { lng: 118.127294, lat: 24.438853 };
var BMap = /** @class */ (function (_super) {
    __extends(BMap, _super);
    function BMap(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            enableDragging: true,
        };
        return _this;
    }
    BMap.prototype.checkFilters = function (filters, tech) {
        var pass = true;
        if (filters.product != "" &&
            filters.product != "none" &&
            !tech.Products.includes(filters.product)) {
            pass = false;
        }
        if (filters.region != "" &&
            filters.region != "none" &&
            !tech.Region.includes(filters.region)) {
            pass = false;
        }
        return pass;
    };
    BMap.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { style: { height: '400px', marginTop: 10 } },
                react_1.default.createElement(react_baidu_maps_1.BaiduMap, { id: 'baidu-map', mapUrl: "http://api.map.baidu.com/api?v=2.0&ak=jsCbv8RPiquDEbijwHCDLOtOmSn5UXgc", defaultCenter: this.props.geolocationCenter, defaultZoom: this.props.geolocationZoom, mapContainer: react_1.default.createElement("div", { style: { height: "400px" } }), onMoveend: function () {
                        var sw = this.getBounds().getSouthWest();
                        var ne = this.getBounds().getNorthEast();
                        this.props.boundsChanged(sw, ne);
                    }, onZoomend: function () {
                        var sw = this.getBounds().getSouthWest();
                        var ne = this.getBounds().getNorthEast();
                        this.props.boundsChanged(sw, ne);
                    }, onTouchend: function () {
                        var sw = this.getBounds().getSouthWest();
                        var ne = this.getBounds().getNorthEast();
                        this.props.boundsChanged(sw, ne);
                    } },
                    this.props.techs.map(function (tech, index) {
                        if (_this.checkFilters(_this.props.filters, tech)) {
                            return (react_1.default.createElement(react_baidu_maps_1.Marker, { key: index, onClick: function () { return _this.props.onMapMarkerClick(index); }, position: {
                                    lat: tech.Location.lat,
                                    lng: tech.Location.lng,
                                } },
                                react_1.default.createElement(react_baidu_maps_1.InfoWindow, { content: "Company: ".concat(tech.Company, "\nPhone: ").concat(tech.Phone), offset: { width: 0, height: -20 } })));
                        }
                        else {
                            return react_1.default.createElement("div", { key: index });
                        }
                    }),
                    react_1.default.createElement(react_baidu_maps_1.NavigationControl, { type: "small", anchor: "top_right", offset: { width: 20, height: 20 } })))));
    };
    return BMap;
}(react_1.default.Component));
exports.default = BMap;
